import React from 'react';

// All icons: duotone (primary stroke + accent highlights via CSS var)
// viewBox 48x48, currentColor-based, 1.5px stroke default

const base = (size, strokeWidth) => ({
  width: size, height: size, viewBox: '0 0 48 48',
  fill: 'none', stroke: 'currentColor', strokeWidth,
  strokeLinecap: 'round', strokeLinejoin: 'round',
});

const accentStyle = { color: 'var(--accent, #00D4FF)' };

export function SteamExterior({ size = 40, strokeWidth = 1.5, ...rest }) {
  return (
    <svg {...base(size, strokeWidth)} {...rest}>
      <g style={accentStyle} stroke="currentColor">
        <path d="M12 10 C 14 8, 16 12, 18 10" />
        <path d="M22 8 C 24 6, 26 10, 28 8" />
        <path d="M32 10 C 34 8, 36 12, 38 10" />
      </g>
      <path d="M8 34 L 10 26 L 16 22 L 32 22 L 38 26 L 40 34" />
      <path d="M6 34 L 42 34" />
      <circle cx="15" cy="36" r="3" />
      <circle cx="33" cy="36" r="3" />
      <path d="M16 22 L 18 26 L 30 26 L 32 22" />
    </svg>
  );
}

export function Interior({ size = 40, strokeWidth = 1.5, ...rest }) {
  return (
    <svg {...base(size, strokeWidth)} {...rest}>
      <path d="M8 12 L 40 12 L 42 20 L 42 38 L 6 38 L 6 20 Z" />
      <path d="M8 20 L 40 20" />
      <rect x="12" y="24" width="9" height="10" rx="1" />
      <rect x="27" y="24" width="9" height="10" rx="1" />
      <g style={accentStyle} stroke="currentColor">
        <path d="M24 27 L 22 30 C 22 32, 26 32, 26 30 Z" />
      </g>
    </svg>
  );
}

export function FullPackage({ size = 40, strokeWidth = 1.5, ...rest }) {
  return (
    <svg {...base(size, strokeWidth)} {...rest}>
      <g style={accentStyle} stroke="currentColor">
        <path d="M10 10 L 12 12 M 12 10 L 10 12" />
        <path d="M38 12 L 40 14 M 40 12 L 38 14" />
        <path d="M42 28 L 44 30 M 44 28 L 42 30" />
        <path d="M6 28 L 8 30 M 8 28 L 6 30" />
      </g>
      <path d="M8 34 L 10 26 L 16 22 L 32 22 L 38 26 L 40 34" />
      <path d="M6 34 L 42 34" />
      <circle cx="15" cy="36" r="3" />
      <circle cx="33" cy="36" r="3" />
      <path d="M16 22 L 18 26 L 30 26 L 32 22" />
      <g style={accentStyle} stroke="currentColor">
        <path d="M20 24 L 28 24" />
      </g>
    </svg>
  );
}

export function Seat({ size = 40, strokeWidth = 1.5, ...rest }) {
  return (
    <svg {...base(size, strokeWidth)} {...rest}>
      <path d="M14 8 L 30 8 Q 32 8 32 10 L 32 26 L 14 26 L 14 10 Q 14 8 16 8" />
      <path d="M12 26 L 34 26 L 34 34 Q 34 36 32 36 L 14 36 Q 12 36 12 34 Z" />
      <path d="M16 36 L 16 40 M 30 36 L 30 40" />
      <g style={accentStyle} stroke="currentColor">
        <path d="M38 18 C 40 16, 42 20, 44 18" />
        <path d="M38 26 C 40 24, 42 28, 44 26" />
      </g>
    </svg>
  );
}

// Vehicle category icons for booking step 0 are sourced from lucide-react.
// See src/components/icons/index.js — VehicleCar = lucide.Car, VehicleMotorcycle = lucide.Motorbike.
